import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
const json = {
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page28/Key/answerKeyE2.png",
    component: T6,
    // isHello:false,
    isHiddenCheck: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>
        
    //     `,
    //   },
    // ],
    // overflowY:'auto',
    // maxHeight: '17cm',
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
        <b>Câu b).</b><br>
        Bước 1: Kéo thả cây thước vào hình để đo góc theo yêu cầu của đề bài.<br><br>
        Bước 2: Điền câu trả lời vào chỗ chấm.</span>
          <video src="Audios/guide/p28_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,
        inputTop: "350px",
        inputLeft: "842px",
        ResultProtractor:[
          {
            textResult: 120,
            styleResult:{
              top: -233,
              left:-136
            }
          },
          {
            textResult: 120,
            styleResult:{
              top:33,
              left:-414
            },
          },
        ],
        result: [
          {
            id: 0,
            top: -18, // top cây thước sau khi đặt vô hình
            left: 311, // left cây thước sau khi đặt vô hình
            rotate: 106,
          },
          {
            id: 1,
            top: -18, // top cây thước sau khi đặt vô hình
            left: 311, // left cây thước sau khi đặt vô hình
            rotate: 166,
          },
        ],
      },
    ],
    // hideBtnFooter: true,
    maxLength: 4,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "1px dotted black",
      textAlign: "center",
    },
    inputSize: 100,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: ``,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        
        <div style='display:flex'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>2</b>
        	</div>
         Con nhện bò theo một trong hai đường đi màu đỏ hoặc màu xanh để về tổ (như hình vẽ). 
        </div>
        
      <div style="position: relative; width: 1000px">
        <img src="/img/FriendsPlus/Page28/E2/1.jpg"  style="width:220mm;height:90mm;" ><br><br>
        <div >
             a) Tìm đường đi cho nhện, biết rằng đường đi này có ít nhất một góc tù.<br>
             &emsp;- Đường nhện đi có ít nhất một góc tù là đường màu # <br>
             b) Dùng thước đo góc để xác định số đo của góc đỉnh O, cạnh OM, cạnh ON.<br>
             &emsp;- Góc đỉnh O, cạnh OM, ON có số đo là # <sup>o</sup>
        </div>
        <div  style="position: absolute; top: 148px; left: 506px;background-color: red; border-radius: 50%; width:8px;height:8px;z-index:1">
        </div>
      </div>
      <div
          id="protractor"
          style="position: absolute;top: 104px;left: 785px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview3.png"
            style="width: 400px"
            alt="image"
          />
        </div>
       
      
        `,
        answer: ["Xanh", "120"],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page28/Key/E3answerKey.png",
    component: T6,
    // isHello:false,
    isHiddenCheck: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Viết số giờ thích hợp vào ô trống.</span>
        <video src="Audios/guide/p28_e2.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    // hideBtnFooter: true,
    // maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted",
      textAlign: "center",
    },
    inputSize: 200,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: ``,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    questions: [
      {
        title: `
        <div style='display:flex; '>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:70px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>3</b>
        	</div>
          a) Quan sát các mặt đồng hồ dưới đây rồi cho biết lúc mấy giờ thì kim giờ và kim phút tạo thành góc nhọn, góc tù, góc bẹt, góc vuông.
        </div>
        <img   src="/img/FriendsPlus/Page28/E3/1.jpg" style='height:5cm; margin-left: 110px'/>
        <div style='margin:20px 100px'>
        <table border='1' style='margin-top:50px; margin-bottom: 60px'>
          <tr>
              <th style='width:6cm;text-align:center '>Góc nhọn</th>
              <th style='width:6cm;text-align:center '>Góc tù</th>
              <th style='width:6cm;text-align:center '>Góc bẹt</th>
              <th style='width:6cm;text-align:center '>Góc vuông</th>
          </tr>
          <tr>
              <td style='text-align:center'>#</td>
              <td style='text-align:center'>#</td>
              <td style='text-align:center'>#</td>
              <td style='text-align:center'>#</td>
          </tr>
          
        </table>
        </div>
        b) Em hãy tìm một thời điểm khác mà khi đó kim giờ và kim phút của đồng hồ tạo thành một góc vuông.<br>
        Thời điểm khác mà kim giờ và kim phút của đồng hồ tạo thành một góc vuông lúc: <input id='4' width='900px'; text-align='left'>
        `,
        answer: ["2", "4", "6", "9", ""],
      },
    ],
  },
  4: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E1",
    audio: "",
    video: "",
    // protractor: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page28/Key/E4answerKey.jpg",
    component: T6,
    // isHello:false,
    inputSize: 80,
    maxLength: 2,
    isHiddenCheck: true,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "2px dotted gray",
      fontSize: "24px",
      textAlign: "center",
      textTransform: "uppercase",
    },
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Quan sát hình rồi điền đáp án vào chỗ chấm.</span>
        <video src="Audios/guide/p28_e3.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    titleQuestion: [
      {
        title: `
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex; align-items: flex-start; max-width: 1050px'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:95px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>4</b>
        	</div>
          Có một bánh xe bằng gỗ đã hỏng (như hình vẽ). Con mọt gỗ đang gặm một trong hai cái nan xe màu đỏ. Biết nan xe đó và một nan xe màu xanh tạo thành một góc tù.<br>
          Tìm nan xe mà con mọt gỗ đang gặm.
        </div> 
        <div style='display:flex'>
        
				  <div style='display:flex; margin-top:100px;margin-left:50px'>
            <b>Con mọt gỗ đang gặm nan hoa: #</b>
          </div>
				  <img src='img/FriendsPlus/Page28/E4/1.jpg' style='width: 11cm; height: 9cm; margin-bottom: 50px; margin-left: 10px'  />
				</div>
				
        `,
        answer: ["B"],
      },
    ],
  },
};

export default json;
